/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: Providers.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  27.09.22 10:13 am.
 * Last modified: 27.09.22 10:13 am.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { FavoritesProvider } from './contexts/FavoriteContext';
import { SectionContainerRefProvider } from './contexts/SectionContainerRefContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { TranslationsProvider } from './contexts/TranslatorContext';
import eventStore from './eventStore';

const Providers = ({ children }: { children: any }) => {
    return (
        <TranslationsProvider value={eventStore.TRANSLATIONS}>
            <SettingsProvider value={eventStore.SETTINGS}>
                <FavoritesProvider value={eventStore.FAVORITES}>
                    <SectionContainerRefProvider value={null}>{children}</SectionContainerRefProvider>
                </FavoritesProvider>
            </SettingsProvider>
        </TranslationsProvider>
    );
};

export default Providers;
